let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4Ds6p")).then(() => parcelRequire('3T9g6'));